import { respTransformer } from './helpers/resUtil';
import Preloader from '../../common/preloader';
import articleListEventObserver from './articleList';
import PushState from '../../common/pushState';
import Ajax from '../../common/ajax';
import PaginationEventHandler from './paginationEventHandler';
import Parameter from '../../common/parameter';
import { scrollToTop } from '../../common/utils';

const AJAX_QUALIFIER = 'ajax=true';

export default class PageController {
    /**
    * Initializes search results page components
    */
    static init() {
        const el = document.querySelector('.controlbar__bottom');

        new PaginationEventHandler(el, {
            pagination: '.pagination',
            resultKey: 'controlbarBottom'
        });

        // preloader
        this.preloader = new Preloader();
        // subscribe articleListService events
        articleListEventObserver.on(articleListEventObserver.EVENTS.PAGINATION, (data) => this.paginateResults(data));
        // Update history with first load URI
        window.history.replaceState({}, document.title, document.location.href);
    }


    /**
    * Paginate search results
    * @param {object} data - Pagination url
    */
    static paginateResults(data) {
        this.searchArticles(data.url);
    }

    static getArticlesByUrl(url) {
        this.preloader.show();
        Ajax.get(url)
            .then(respTransformer)
            .then((response) => {
                this.updateArticleListPage(response);
                this.preloader.hide();
            }).catch(() => {
                //hiding preloader when any exception occured.
                this.preloader.hide();
            });
    }

    /**
   *  Method to List products based on Page Number
   * @param {object} url - url hit to get ajax response
   */
    static searchArticles(url) {
        const currentPath = window.location.origin + window.location.pathname;
        const pageChoice = Parameter.get('pageChoice', url);
        const pageUrl = currentPath+'?pageChoice='+pageChoice;
        // Make a request with updated URI

        if (url.indexOf(AJAX_QUALIFIER) === -1) {
            url = pageUrl+'&'+ AJAX_QUALIFIER;
        }
        PushState.push(document.title, pageUrl);
        this.getArticlesByUrl(url);
    }

    /**
    *  Response from getArticleList's XHR request
    **/
    static updateArticleListPage(res) {
        document.getElementsByClassName('artlicle-list-container')[0].innerHTML = res.articleContent;
        document.getElementsByClassName('controlbar__bottom')[0].innerHTML = res.controlbarBottom;
        articleListEventObserver.emit(articleListEventObserver.EVENTS.RESULTS, res);
        const el = document.querySelector('.controlbar__bottom');

        new PaginationEventHandler(el, {
            pagination: '.pagination',
            resultKey: 'controlbarBottom'
        });

        scrollToTop();
    }
}



// WEBPACK FOOTER //
// /src/pages/main/pageController.js